import { applyMask, MaskMode } from '@intigral/utils';
import { OutstreamAdCarousel } from '../types/iCarousel.types';

interface BannerImages {
    background_expanded?: string;
    background?: string;
}

/**
 * Given an OutstreamAdCarousel, returns an object with the key being the image url key and the value being the image url.
 * @param {OutstreamAdCarousel} carousel - The OutstreamAdCarousel to process.
 * @returns {BannerImages} - An object with the image url key and the image url value.
 */
export const getBannerImages = (carousel: OutstreamAdCarousel): BannerImages => {
    const {
        data: {
            content: [{ imageUrls }],
        },
    } = carousel;
    const banners: BannerImages = {};
    imageUrls.forEach((el) => (banners[el.key] = el.urlWeb));
    return banners;
};

export const getAdConfig = (carousel: OutstreamAdCarousel) => {
    const {
        data: {
            content: [{ adConfig }],
        },
    } = carousel;
    return adConfig;
};


